import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { weekDaysShort } from '@utils';
import { AdapterString } from "../calendar/views/editMeeting/components/AdapterString";

const customWeekDays = weekDaysShort.map((day) => new AdapterString(day) as string);

export class DateBlockAdapter extends AdapterDateFns {
  getWeekdays = (): string[] => customWeekDays;
}
